import { render } from "./OverlayHelpDialog.vue?vue&type=template&id=748834ba&scoped=true&ts=true"
import script from "./OverlayHelpDialog.vue?vue&type=script&lang=ts"
export * from "./OverlayHelpDialog.vue?vue&type=script&lang=ts"

import "./OverlayHelpDialog.vue?vue&type=style&index=0&id=748834ba&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-748834ba"]])

export default __exports__